import { render, staticRenderFns } from "./tickChart.vue?vue&type=template&id=b6372e24&scoped=true"
import script from "./tickChart.vue?vue&type=script&lang=js"
export * from "./tickChart.vue?vue&type=script&lang=js"
import style0 from "./tickChart.vue?vue&type=style&index=0&id=b6372e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6372e24",
  null
  
)

export default component.exports